import { useState } from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function NavMenuContent() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [hovered, setHovered] = useState<string | null>(null);
  return <div className="bg-background text-foreground border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-10">
          <div className="flex items-center gap-1">
            <Link to="https://www.facebook.com" aria-label="Facebook" onMouseEnter={() => setHovered("fb")} onMouseLeave={() => setHovered(null)} newTab className="relative flex items-center justify-center w-7 h-7 rounded-sm transition-all duration-300 text-muted-foreground hover:text-primary-foreground overflow-hidden group">
              <span className="absolute inset-0 bg-primary scale-0 group-hover:scale-100 transition-transform duration-300 origin-center rounded-sm" />
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor" className="relative z-10">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
              </svg>
            </Link>

            <Link to="https://www.youtube.com" aria-label="YouTube" onMouseEnter={() => setHovered("yt")} onMouseLeave={() => setHovered(null)} newTab className="relative flex items-center justify-center w-7 h-7 rounded-sm transition-all duration-300 text-muted-foreground hover:text-primary-foreground overflow-hidden group">
              <span className="absolute inset-0 bg-primary scale-0 group-hover:scale-100 transition-transform duration-300 origin-center rounded-sm" />
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor" className="relative z-10">
                <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.96-1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z" />
                <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="white" />
              </svg>
            </Link>

            {}
            {!loading && menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="text-xs text-muted-foreground hover:text-primary transition-colors px-2 hidden md:inline-block">
                {item.label}
              </Link>)}
          </div>

          <div className="flex items-center gap-4 sm:gap-6">
            <Link to="tel:3024691979" className="flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors duration-200 group">
              <span className="flex items-center justify-center w-5 h-5 rounded-lg border border-border group-hover:border-primary group-hover:bg-primary/10 transition-all duration-200">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="group-hover:text-primary transition-colors duration-200">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.16 6.16l1.27-.85a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
              </span>
              <span className="hidden sm:inline tracking-wide">302-469-1979</span>
            </Link>

            <Link to="mailto:contacto@rio3d.com.co" className="flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors duration-200 group">
              <span className="flex items-center justify-center w-5 h-5 rounded-lg border border-border group-hover:border-primary group-hover:bg-primary/10 transition-all duration-200">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="group-hover:text-primary transition-colors duration-200">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </span>
              <span className="hidden sm:inline tracking-wide">contacto@rio3d.com.co</span>
            </Link>
          </div>
        </div>
      </div>

      <div className="h-px bg-gradient-to-r from-transparent via-primary/40 to-transparent" />
    </div>;
}
export default function HeaderTopBar() {
  return <header id="header" className="dark">
      <MenuProvider menu_id="16">
        <NavMenuContent />
      </MenuProvider>
    </header>;
}